import React from 'react';
import clsx from 'clsx';

import scss from './SectionWrapper.module.scss';

function SectionWrapper({ title, Subtitle, children, Filters, className, alignTitleTop = false }) {
  return (
    <div className={clsx(scss.section, className)}>
      <div className={scss.sectionHeader}>
        <div className={clsx(scss.sectionTitle, alignTitleTop && scss.alignTop)}>
          {title ? <h3 className={scss.title}>{title}</h3> : null}
          {Filters ? Filters : null}
        </div>

        {Subtitle ? <Subtitle /> : null}
      </div>
      <div className={scss.sectionContent}>{children}</div>
    </div>
  );
}

export default SectionWrapper;
